<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="row_create">
    <v-data-table
        :headers="headers"
        :items="values"
        :hide-default-header="empty"
        :height="values.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-currency-formula-dialog ref="dialog"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {CurrencyFormula} from "@/modules/redactor/models/currency/CurrencyFormula";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RCurrencyFormulaDialog from "@/modules/redactor/views/currency/r-currency-formula-dialog.vue";

export default {
  name: "r-currency-formula-panel",
  components: {RCurrencyFormulaDialog, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Formulas"),
    items: VueTypes.arrayOf(CurrencyFormula)
  },
  data: () => ({
    headers: [
      {text: 'Name', value: 'name'},
      {text: 'Components', value: 'components.length'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    },
    empty() {
      return this.values.length === 0;
    }
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.values.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.values.indexOf(item);
            this.values.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.values.indexOf(item);
        this.values.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    }
  }
}
</script>
